import { CallOutlined, EmailOutlined } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import BoldText from "~/src/components/Text/BoldText";
import Text, { TextVariant } from "~/src/components/Text/Text";
import ButtonDefault, { ButtonVariant } from "../../components/Button/ButtonDefault";

export default function (): JSX.Element {
  const { t } = useTranslation();
  return (
    <div className="mx-6 mt-0 pt-6 bg-banner3 text-ldir-brown-900 h-[calc(100vh-64px)] flex flex-col justify-between min-h-fit bg-cover bg-top-left">
      <div className="text-lg">
        <div className=" mx-6 mb-8 mt-20 text-3xl text-[2rem] ">
          <h2 className="font-bold">{t("pages.kontakt.hjelp")}</h2>
          <Text variant={TextVariant.xxxlarge} className="flex flex-col">
            {t("pages.kontakt.kontakt")}
            <span>{t("pages.kontakt.gratis")}</span>
          </Text>
        </div>
        <BoldText text={t("pages.kontakt.text")} numBoldWords={3} />
        <BoldText className="mt-3" text={t("pages.kontakt.textpt2")} numBoldWords={4} />
      </div>
      <div className="flex gap-5 mb-6 mt-10 flex-wrap justify-center">
        <div className="min-w-fit grow">
          <ButtonDefault
            id="EmailAdress"
            variant={ButtonVariant.Primary}
            onClick={() => (window.location.href = "mailto:support@naturdata.no")}
            label="support@naturdata.no"
            icon={<EmailOutlined />}
          />
        </div>
        <div className="min-w-fit grow">
          <ButtonDefault
            id="PhoneNo"
            variant={ButtonVariant.Primary}
            onClick={() => (window.location.href = "tel:+47 74 33 53 10")}
            label="743 353 10"
            icon={<CallOutlined />}
          />
        </div>
      </div>
    </div>
  );
}
